<script>
import axios from '@/utils/axios';
// import { getBranches } from '@/utils/branch';
import { useLeadMetaStore } from '@/stores/useLeadMetaStore';
import { mapState } from 'pinia'

export default {
 inject: ['setLoading'], 
  data() {
   return {
    errors: {},
    title: "Settings",
    text: "Administration",
    text1: "Settings",
    // data: [],
    searchText: '',
    columns: [
      {
        title: 'S.No',
        dataIndex: 'SNo',
        key: 'SNo',
      },
      {
        title: 'Branch Name',
        dataIndex: 'BranchName',
        key: 'BranchName',
      },
      {
        title: 'Branch Code',
        dataIndex: 'BranchCode',
        key: 'BranchCode',
      },
      {
        title: 'Actions',
        key: 'action',
      },
    ],
    rowSelection: null,
   };
 },

 computed: {
  ...mapState(useLeadMetaStore, ['branches']),
  filteredData() {
    if (!this.searchText) return this.branches;
    const search = this.searchText.toLowerCase();
    return this.branches.filter(item => item.name?.toLowerCase().includes(search));
  },
},
async mounted(){
  const store = useLeadMetaStore()
  if (!store.branches.length) {
    this.setLoading(true)
    try { await store.refreshBranches() }
    finally { this.setLoading(false) }
  }
},

 methods: {


  async onBranchUpdated(){
    const store = useLeadMetaStore()
    await store.refreshBranches()
  },
 async branches(){
  this.setLoading(true);
  try{
    const response = await axios.get('/branches');
    this.data = response.data.data;
  }catch(error){
    this.$swalToast(error.message);
  }finally{
    this.setLoading(false);
  }
},

 },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="head-icons ms-2">
 
</div>
</div>
<!-- /Breadcrumb -->

<settings-tab></settings-tab>
<div class="row">
<general-sidebar></general-sidebar>
<div class="col-xl-9">
<div class="card">
<div class="card-body">
<div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
<h4>Branches Details</h4>
<div>
<a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#branch_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.branchModal.branch();"><i class="ti ti-circle-plus me-2"></i>Add Branch</a>
</div>
</div>
<div class="card-body p-0">
<div class="card mb-0">
<div class="card-header d-flex align-items-center justify-content-between">
<a-input v-model:value="searchText" placeholder="Search branch name..." allow-clear style="width: 300px;"/>
</div>
<div class="custom-datatable-filter table-responsive">

<a-table v-if="filteredData.length" class="table datatable thead-light" :columns="columns" :data-source="filteredData"
  :row-selection="rowSelection">
  <template #bodyCell="{ column, record, index }">
    <template v-if="column.key === 'SNo'"> {{ index + 1 }}. </template>   
    <template v-if="column.key === 'BranchName'">
      <h6 class="fs-14 fw-medium">
        <router-link to="#">{{ record.name }}</router-link>
      </h6>
    </template>
    <template v-if="column.key === 'BranchCode'">{{ record.code }}</template>
    <template v-if="column.key === 'action'">
      <div class="action-icon d-inline-flex">
        <a href="javascript:void(0);" class="me-2" data-bs-toggle="modal" data-bs-target="#branch_modal" @click="$refs.branchModal.branch(record)">
          <i class="ti ti-edit"></i>
        </a>
        <a href="javascript:void(0);" class="text-danger" data-bs-toggle="modal" data-bs-target="#delete_modal" @click="$refs.branchModal.branch(record)">
          <i class="ti ti-trash"></i>
        </a>
      </div>
    </template>
  </template>
</a-table>

<div v-else class="p-3 text-center text-muted">
  No records found.
</div>

</div>
  </div>
</div>
</div>
</div>

</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->
 <branch-modal ref="branchModal" @updated="onBranchUpdated"></branch-modal>
</template>
